module.exports = __webpack_public_path__ + "media/video_04.ca43d665.mp4";